/**
 *  Converts a string into Capitalize
 *
 * 'abc' => 'Abc'
 */
import greekUtils from '../../lib/greek-utils'

function toGreeklish(value) {
  if (!value && value !== 0) return ''
  value = value.toString()

  return greekUtils.toGreeklish(value)
}

export default toGreeklish
